import { Box, Modal } from "@mui/material";
import { useState } from "react";
import DeleteUserModal from "./Notes/DeleteUserModal";
import EditButtonMobile from "./Buttons/EditButtonMobile";
import DeleteButtonUserDataMobile from "./Buttons/DeleteButtonUserDataMobile";
import EditRoleMobile from "./forms/EditRoleMobile";

function FormLineMedium5mobile(props) {
  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    width: "92vw",
    maxWidth: 420,
    borderRadius: 6,
    bgcolor: "background.paper",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
    padding: "12px",
  };

  const styleModalGeneral = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",

    width: "92vw",
    maxWidth: 440,
    borderRadius: 6,
    backgroundColor: "white",
    boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
    padding: "12px",
  };

  const [openEditRole, setOpenEditRole] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleOpenEditRole = () => setOpenEditRole(true);
  const handleCloseEditRole = () => setOpenEditRole(false);

  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  return (
    <div
      className={
        props.color === "1"
          ? "formLineMedium5Mobile light-grey-form"
          : "formLineMedium5Mobile grey-form"
      }
    >
      <Modal
        open={openEditRole}
        onClose={handleCloseEditRole}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        keepMounted
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(15,23,42,0.45)",
              backdropFilter: "blur(2px)",
            },
          },
        }}
      >
        <Box sx={styleModalGeneral}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 6,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 16 }}>Edit role</div>
          </div>
          <EditRoleMobile
            closemodal={handleCloseEditRole}
            userName={props.userName}
            roleUser={props.userRole}
            userId={props.userId}
          />
        </Box>
      </Modal>
      <Modal
        open={showDeleteModal}
        onClose={closeDeleteModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        keepMounted
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(15,23,42,0.45)",
              backdropFilter: "blur(2px)",
            },
          },
        }}
      >
        <Box sx={styleDeleteModal}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 6,
            }}
          >
            <div style={{ fontWeight: 700, fontSize: 16, color: "#b91c1c" }}>
              Delete user
            </div>
          </div>
          <DeleteUserModal onClose={closeDeleteModal} uid={props.userId} />
        </Box>
      </Modal>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          gap: 8,
          boxSizing: "border-box",
        }}
      >
        {/* Colonne 1 : Email */}
        <div
          className="role-line-block1-mobile"
          style={{
            flex: "0 0 33.333%",

            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "2px 0",
            width: "auto",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          {props.userEmail}
        </div>

        {/* Colonne 2 : Rôle */}
        <div
          className="role-line-block1-mobile"
          style={{
            flex: "0 0 33.333%",
            minWidth: 0,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            padding: "2px 0",
            width: "auto",
            maxWidth: "100%",
            minWidth: 0,
          }}
        >
          {props.userRole}
        </div>

        {/* Colonne 3 : Actions */}
        <div
          className="role-line-block3-mobile"
          style={{
            flex: "0 0 33.333%",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 8,
            backgroundColor: "lavender",
            padding: "2px 0",
          }}
        >
          <EditButtonMobile
            title="Edit"
            handleOpen={handleOpenEditRole}
            onClick={(e) => {
              if (e && e.stopPropagation) e.stopPropagation();
              handleOpenEditRole();
            }}
          />
          <DeleteButtonUserDataMobile
            handleOpen={(e) => {
              if (e && e.stopPropagation) e.stopPropagation();
              closeDeleteModal();
              openDeleteModal();
            }}
            onClick={(e) => {
              if (e && e.stopPropagation) e.stopPropagation();
              closeDeleteModal();
              openDeleteModal();
            }}
            closeModal={closeDeleteModal}
          />
        </div>
      </div>
    </div>
  );
}

export default FormLineMedium5mobile;
